import {
  FETCH_DEVICES_REQUEST,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  REMOVE_DEVICE_REQUEST,
  REMOVE_DEVICE_SUCCESS,
  REMOVE_DEVICE_FAILURE,
  RENAME_DEVICE_REQUEST,
  RENAME_DEVICE_SUCCESS,
  RENAME_DEVICE_FAILURE,
  CLEAR_DEVICE_ERROR
} from '../actions/types';

const initialState = {
  devices: [],
  loading: false,
  error: null,
  pendingOperations: {}
};

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Devices
    case FETCH_DEVICES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DEVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        devices: action.payload,
        error: null
      };
    case FETCH_DEVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Remove Device
    case REMOVE_DEVICE_REQUEST:
      return {
        ...state,
        pendingOperations: {
          ...state.pendingOperations,
          [action.payload]: 'removing'
        },
        error: null
      };
    case REMOVE_DEVICE_SUCCESS:
      return {
        ...state,
        devices: state.devices.filter(device => device.id !== action.payload),
        pendingOperations: {
          ...state.pendingOperations,
          [action.payload]: undefined
        },
        error: null
      };
    case REMOVE_DEVICE_FAILURE:
      return {
        ...state,
        pendingOperations: Object.keys(state.pendingOperations).reduce((acc, key) => {
          if (state.pendingOperations[key] !== 'removing') {
            acc[key] = state.pendingOperations[key];
          }
          return acc;
        }, {}),
        error: action.payload
      };
      
    // Rename Device
    case RENAME_DEVICE_REQUEST:
      return {
        ...state,
        pendingOperations: {
          ...state.pendingOperations,
          [action.payload]: 'renaming'
        },
        error: null
      };
    case RENAME_DEVICE_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device => 
          device.id === action.payload.id 
            ? { ...device, name: action.payload.name } 
            : device
        ),
        pendingOperations: {
          ...state.pendingOperations,
          [action.payload.id]: undefined
        },
        error: null
      };
    case RENAME_DEVICE_FAILURE:
      return {
        ...state,
        pendingOperations: Object.keys(state.pendingOperations).reduce((acc, key) => {
          if (state.pendingOperations[key] !== 'renaming') {
            acc[key] = state.pendingOperations[key];
          }
          return acc;
        }, {}),
        error: action.payload
      };
      
    // Clear Error
    case CLEAR_DEVICE_ERROR:
      return {
        ...state,
        error: null
      };
      
    default:
      return state;
  }
};

export default deviceReducer; 